export const Teal = (
    <svg fill="currentColor" height="19" width="19">
        <path d="M17.849 6.64 6.639 17.849a3.804 3.804 0 1 1-5.38-5.38l11.21-11.21a3.804 3.804 0 0 1 5.38 5.38z" />
    </svg>
);
